export default function pergasClone() {
  const deepClone = (object) => {
    let clonedObject = new Object();

    for (let key in object) {
      const originValue = object[key];
      if (originValue === null) clonedObject[key] = null;
      else if (!Array.isArray(originValue)) {
        if (typeof originValue !== "object") {
          clonedObject[key] = originValue;
        } else {
          clonedObject[key] = deepClone(originValue);
        }
      } else {
        let mappedArray = [];
        for (let item of originValue) {
          mappedArray.push(deepClone(item));
        }
        clonedObject[key] = mappedArray;
      }
    }
    return clonedObject;
  };
  return deepClone;
}
